import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'localizednumber' })
export class LocalizedNumberPipe implements PipeTransform {

    lang = this.translate.currentLang;

    constructor(
        private translate: TranslateService
    ) { }

    transform(value) {

        if (value) {
            return new Intl.NumberFormat(this.lang).format(value);
        }

        return value;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/localized-number.pipe.ts